import {
  CreateOidcIdentityProviderDto,
  OidcIdentityProviderDto,
  OidcIdentityProvidersApi,
} from '../../../../api-client';
import { useMutation, UseMutationResult } from 'react-query';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../../common/types/errorRespose';
import { UseMutationOptions } from 'react-query/types/react/types';
import { getApiConfiguration } from '../../../../common';

type UseCreateOidcProvider = (
  options?: Omit<
    UseMutationOptions<
      AxiosResponse<OidcIdentityProviderDto>,
      ErrorResponse,
      CreateOidcIdentityProviderDto
    >,
    'mutationFn'
  >,
) => UseMutationResult<
  AxiosResponse<OidcIdentityProviderDto>,
  ErrorResponse,
  CreateOidcIdentityProviderDto
>;

export const useCreateOidcProvider: UseCreateOidcProvider = (
  options,
) => {
  const tenantId = localStorage.getItem('tenantId') as string;
  const oidcIdentityProvidersApi = new OidcIdentityProvidersApi(getApiConfiguration());
  return useMutation(
    (createIdentityProviderDto: CreateOidcIdentityProviderDto) =>
      oidcIdentityProvidersApi.createOidcProvider(tenantId, createIdentityProviderDto),
    options,
  );
};
